import { CSSProperties, ReactNode } from 'react';

interface RevealProps {
  delay?: number;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

export default function Reveal({ delay = 0, className, style, children }: RevealProps) {
  return (
    <div
      className={['vara2-reveal', className].filter(Boolean).join(' ')}
      style={{ animationDelay: `${delay}ms`, ...style }}
    >
      {children}
    </div>
  );
}
